export default __webpack_public_path__ + "static/MikeJohnson-c81449034d4a89f0f282c0087c3ab66d.jpg";